export default __webpack_public_path__ + "static/media/breakfast_15.e65e35ea.jpg";